import { Chip, Div, Icon, Label, useWindowSize, Button, Loader } from "@grassrootly/rn-core";
import { Image } from "react-native";
import { images } from "../../../layout/assets";
import { GameTeams } from "../lib";
import { EditGameAttendeesProps, useEditGameAttendees } from "./useEditGameAttendees";
import { GameType } from "../../../screens/new-game/NewGame.types";

export default function EditGameAtendees(params: EditGameAttendeesProps) {
  const { isMobile } = useWindowSize();
  const {
    filteredAttendees,
    attendees,
    updateAttendance,
    updatePosition,
    isAttending,
    isInTeam,
    isGoalkeeper,
    addInTeam,
    unsavedChanges,
    saveChanges,
    clearChanges,
    isUpdating,
  } = useEditGameAttendees(params);
  const onAddPlayerPress = () => {
    params?.navigation?.navigate("add-player", { id: params.game?.id, whereToAdd: "game" });
  };
  return (
    <Div classNames={["flex1", "bgNeutralDarkerDark"]}>
      {/* Header with attendance stats and add button */}
      <Div classNames={["flexRow", "mb-{16}", "alignItemsCenter", "justifyContentSpaceBetween", "ph8", "pt-{16}", "bgNeutralDarkerDark"]}>
        <Div classNames={["flexRow", "alignItemsCenter"]}>
          <Label type="l3Regular" classNames={["mr-{5}"]}>
            {attendees.filter((a) => a.attended).length}
          </Label>
          <Icon name="check" classNames={["colorSuccessMain"]} />
          <Label type="l3Regular" classNames={["mr-{5}", "ml-{10}"]}>
            {attendees.filter((a) => a.attended == false).length}
          </Label>
          <Icon name="close" classNames={["colorDangerMain"]} />
        </Div>
        <Button
          title="Add Player"
          classNames={["btn", "btnOutlinePrimary"]}
          right={{ name: "person" }}
          onPress={onAddPlayerPress}
        />
      </Div>

      {/* Attendees list */}
      <Div classNames={["flex1", "ph8", "bgNeutralDarkerDark"]}>
        {filteredAttendees.map((attendee, index) => (
          <Div
            key={index}
            classNames={[
              "p16",
              "mb-{8}",
              index % 2 == 0 ? "bgNeutralDarkerMain" : "bgSecondaryMain",
              "flexRow",
              "alignItemsCenter",
            ]}
          >
            <Div classNames={isMobile ? ["flexColumn", "w100"] : ["flexRow", "w100"]}>
              <Div classNames={["flexRow", "alignItemsCenter", !isMobile ? "w50" : "w100"]}>
                <Image
                  style={{ height: 40, width: 40, borderRadius: 40 }}
                  resizeMode="cover"
                  source={
                    attendee.player?.profile_picture ? { uri: attendee.player?.profile_picture } : images.playerAvatar
                  }
                />
                <Label classNames={["pl-{5}"]}>{attendee.player?.name}</Label>
              </Div>
              <Div
                classNames={[
                  "flexRow",
                  !isMobile ? "w50" : "w100",
                  "justifyContentFlexEnd",
                  "alignItemsCenter",
                  isMobile ? "mt-{-5}" : "",
                ]}
              >
                <Div classNames={["dInlineFlex", "flexRow", "alignItemsCenter", "gap8"]}>
                  {isUpdating(attendee.player_id) ? (
                    <Div classNames={[
                      "alignItemsCenter", 
                      "justifyContentCenter", 
                      "p8", 
                      "bgNeutralDarkerContrast", 
                      "rounded",
                      "minW-{60}",
                      "minH-{32}"
                    ]}>
                      <Loader size={16} />
                    </Div>
                  ) : (
                    <>
                      <Chip
                        title={"In"}
                        type={"tag"}
                        onPress={() => updateAttendance(attendee, true)}
                        classNames={[
                          "l4Regular", 
                          isAttending(attendee) === 1 
                            ? "bgPrimaryMain" 
                            : "bgNeutralDarkerContrast",
                          isAttending(attendee) === 1 
                            ? "colorNeutralLighterLight" 
                            : "colorSecondaryContrast"
                        ]}
                      ></Chip>
                      <Chip
                        title={"Out"}
                        type={"tag"}
                        onPress={() => updateAttendance(attendee, false)}
                        classNames={[
                          "l4Regular",
                          isAttending(attendee) === 0 
                            ? "bgPrimaryMain" 
                            : "bgNeutralDarkerContrast",
                          isAttending(attendee) === 0 
                            ? "colorNeutralLighterLight" 
                            : "colorSecondaryContrast"
                        ]}
                      ></Chip>
                      <Chip
                        title={"GK"}
                        type={"tag"}
                        disabled={isAttending(attendee) !== 1}
                        onPress={() => {
                          const newPosition = isGoalkeeper(attendee) ? "PLAYER" : "GK";
                          updatePosition(attendee, newPosition);
                        }}
                        classNames={[
                          "l4Regular",
                          isAttending(attendee) !== 1
                            ? "bgNeutralDarkerContrast"
                            : isGoalkeeper(attendee)
                            ? "bgWarningMain"
                            : "bgNeutralDarkerContrast",
                          isAttending(attendee) !== 1
                            ? "colorNeutralDarkerLight"
                            : isGoalkeeper(attendee)
                            ? "colorNeutralLighterLight"
                            : "colorSecondaryContrast"
                        ]}
                      ></Chip>
                    </>
                  )}
                </Div>
              </Div>
            </Div>
          </Div>
        ))}
      </Div>
    </Div>
  );
}
